import GeneralHelper from "./generalHelper"
import Pattern from "./pattern"
import ColorHelper from "./colorHelper"
import View from "./View";

export default class Thumbnail {
  static protocol()
  {
    return "http" + ( window.PatternBuilder.config().SSL ? "s" : "" );
  }

  static url()
  {
    return (  window.PatternBuilder.config().USE_CDN ? Thumbnail.protocol() + "://" + window.PatternBuilder.config().CDN + '/Core2Doc/' : Thumbnail.protocol() + "://" + window.PatternBuilder.config().SERVICE_BASE + '/Core2/Doc' ) ;
  }

  static render_color_thumb_img$(doc_id, color_tuples, tagged, zoom, width, height, dpi, is_raster) {
    var patternZoom = 1, rasterZoom = 1 ;
    var d = Cx.Defer();
    zoom = parseFloat(zoom);
    if ( zoom != 1 )
    {
      rasterZoom = ( is_raster ) ? zoom : 1 ;
      patternZoom  = ( is_raster ) ? 1 : zoom ; 
    }
    var qs = {
      config: Cx.Core.getConfig()
      , model: {
          Doc: {
              Id: doc_id
          }
      , Colorize: { SpotColorTuples: color_tuples, Type: 'SpotColor' }
      , format: 'Png'
      , PatternZoom: patternZoom //pattern definition
      , Zoom: rasterZoom //resulting raster (tiled and transformed)
      , Width: width
      , Height: height
      , DPI: dpi
      }
      , ident: { SessionId: Cx.User.getSessionId(), SuperUser: Cx.User.isSuperUser() }
    };

    let hash = GeneralHelper.md5Encode(JSON.stringify(qs));

    let thumb = GeneralHelper.getPatternContainersFromLocalStorage('thumb', hash);

    if(thumb)
      return d.resolve(thumb);

    var xhr = new XMLHttpRequest();
    xhr.onreadystatechange = function() {
     if (this.readyState == 4 && this.status == 200)
     {
        var res = this.response;
        var reader = new window.FileReader();
        reader.readAsDataURL(res);
        reader.onloadend = function() {
            GeneralHelper.savePatternContainersToLocalStorage('thumb', hash, reader.result);
            return d.resolve(reader.result);
        }
     }
  }

  let url = Thumbnail.url() + '/ColorizeThumbnail';
  xhr.open('POST', url);
  xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
  xhr.send(JSON.stringify(qs));
  xhr.responseType = 'blob';
  url += '?' + JSON.stringify(qs);
  return d ;
};

static render_thumb_img$(doc_id, zoom, width, height, dpi, fit, render = true ) {
  var d = Cx.Defer();
  var qs = {
    config: Cx.Core.getConfig()
    , model: {
            Doc: {
                    Id: doc_id
            }
    , format: 'Png'
    , Zoom: zoom
    , Width: width
    , Height: height
    , DPI: dpi
    , Fit: fit
    }
    , ident: { SessionId: Cx.User.getSessionId(), SuperUser: Cx.User.isSuperUser() }
  };

  let hash = GeneralHelper.md5Encode(JSON.stringify(qs));

  var thumb = GeneralHelper.getPatternContainersFromLocalStorage('thumb', hash);

  if(thumb)
    return d.resolve(thumb);

  var xhr = new XMLHttpRequest();
  xhr.onreadystatechange = function() {
    if (this.readyState == 4 && this.status == 200)
    {
      var res = this.response;
      var reader = new window.FileReader();
      reader.readAsDataURL(res);
      reader.onloadend = function() {
          GeneralHelper.savePatternContainersToLocalStorage('thumb', hash, reader.result);
          return d.resolve(reader.result);
      }
    }
  }

  xhr.open('POST', Thumbnail.url() + '/Thumbnail' );
  xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
  xhr.send(JSON.stringify(qs));
  xhr.responseType = 'blob';

  return d ;
};

static get_thumb_url(doc_id, color_tuples, tagged, zoom, width, height, dpi, is_raster) {

  var patternZoom = 1, rasterZoom = 1 ;
  if ( zoom != 1 )
  {
    rasterZoom = ( is_raster ) ? zoom : 1 ;
    patternZoom  = ( is_raster ) ? 1 : zoom ; 
  }
  var qs = {
      config: Cx.Core.getConfig()
      , model: {
          Doc: {
              Id: doc_id
          }
      , Colorize: { SpotColorTuples: color_tuples, Tagged: tagged }
      , format: 'Png'
      , PatternZoom: patternZoom //pattern definition
      , Zoom: rasterZoom //resulting raster (tiled and transformed)
      , Width: width
      , Height: height
      , DPI: dpi
      }
      , ident: { SessionId: Cx.User.getSessionId(), SuperUser: Cx.User.isSuperUser() }
  };

  return Thumbnail.url() + '/ColorizeThumbnail?' + encodeURIComponent(JSON.stringify(qs));
};

static load_main_thumbnails(target, patterns, render = true) {
    var ordered = [];
    var not_ordered = [];

    View.wizardLoading(true, true, true);
    
    for ( var i = 0 ; i < patterns.length ; i ++ )
    {
      if ( GeneralHelper.get_display_order_value(patterns[i].Cdl) == Number.MAX_SAFE_INTEGER )
        not_ordered.push(patterns[i]);
      else
        ordered.push(patterns[i]);
    }

    not_ordered = Cx_.sortBy(not_ordered, function(obj) { return obj.Name });
    ordered     = Cx_.sortBy(ordered, function(obj) { return GeneralHelper.get_display_order_value(obj.Cdl); });
    patterns    = ordered.concat(not_ordered);

    let promises = [];

    Cx_.forEach(patterns, function(pattern, i) {

      let p = pattern ;

      var new_p = ( p.Class3 !== undefined && p.Class3 !== "" && ( p.Class3 > new Date().valueOf() ) );

      var is_fav = ( Cx_.filter(window.AppInstance.instance().favorites, function(f) { return f.ExternalID === p.ExternalID }).length > 0 ) ;

      var icon_class = (window.AppInstance.instance().is_fav_search) ? "icon-close-button-heavy delete-favorite-search removeIcon" : (is_fav ? 'icon-favorites-heart-solid favIcon' : 'icon-favorites-heart-outline favIcon');

      var thumb_html = '<div style="position:relative;" class="pattern-select' +
      ( ( window.AppInstance.instance().selected !== null ) && ( GeneralHelper.sanitize_GID(window.AppInstance.instance().selected.ExternalId) === GeneralHelper.sanitize_GID(p.ExternalID) || ( window.AppInstance.instance().selected.metadata !== null && ( GeneralHelper.sanitize_GID(window.AppInstance.instance().selected.metadata.get("parentDocumentID")) === GeneralHelper.sanitize_GID(p.ExternalID) ) ) )
      ? " active" : "") + '" data-patternid="' + p.ExternalID + '" title="' + GeneralHelper.remove_extension(p.Name) + '"><span class="pattern-name">' + GeneralHelper.remove_extension(p.Name) + '</span><div ' + (new_p ? 'class="swatch-new"' : '') + '><div class="pattern-container" style="position: relative;" ><span class="check-logged-in '+icon_class+'" data-external="'+p.ExternalID+'" data-id="'+p.Id+'" id="'+p.Id+'-thumb-span" data-fav="'+is_fav+'"></span><img id="pattern_img_container_'+String(i)+'" class="main-thumb" style="z-index: 1;" onclick="window.load_pattern_and_metafiles(\'' + p.ExternalID + '\', true, 0);" /></div></div>';
      thumb_html += '</div>';
      
      $('#'+target).append(thumb_html);

      View.resize();
    });

    Cx_.forEach(patterns, function (pattern, i) {
        var doc = Cx.Document.fromXmlString(pattern.Cdl);
        var pattern_figure = doc.figures[0];

        var initial_color_set = null;
        if ( ( pattern_figure.metadata.get('colorSet') !== undefined ) && ( ! Pattern.is_raster_pattern(pattern_figure) ) )
            initial_color_set = ColorHelper.get_spotcolor_tuples(pattern_figure)[0];        

        promises.push(Thumbnail.render_color_thumb_img$(pattern.Id
            , initial_color_set
            , false
            , pattern_figure.metadata.get('thumbZoom')
            , pattern_figure.metadata.get('thumbWidth')
            , pattern_figure.metadata.get('thumbHeight')
            , pattern_figure.metadata.get('thumbDPI')
            , Pattern.is_raster_pattern(pattern_figure)
            , render
        ).then(function(thumb_url) {
          if ( render )
          {
            $('#pattern_img_container_'+String(i)).attr('src', thumb_url);           
          }
      })
      .catch(function(e) {
        GeneralHelper.errorOut(e);
      })
    );
    });
    Cx.whenAll(promises).then(function() {
      View.wizardLoading(true, true, false);
    });
  };

  static list_color_thumbnails (doc_id, target, color_tuples) {
    $('#' + target).html('');
    var zoom = window.AppInstance.instance().selected.metadata.get('thumbZoom');
    var width = window.AppInstance.instance().selected.metadata.get('thumbWidth');
    var height = window.AppInstance.instance().selected.metadata.get('thumbHeight');
    var dpi = window.AppInstance.instance().selected.metadata.get('thumbDPI');
    Cx_.forEach(color_tuples, function (color_tuple, id) {
      Thumbnail.render_color_thumb_img$(doc_id, color_tuple, true, zoom, width, height, dpi, false).then(function(content){
        $('#' + target).append('<div class="colorway" id="' + id + '" onclick="window.update_vector_swatches(this);"><img style="" src="' + content + '" /></div>');
        View.resize();
      });
    });
  };
}